import { BlogPost } from '../BlogPosts';
import { welcomeToToastie } from './2025-06-30-welcome-to-toastie';
import { howToPrepForGpApptsWithUnexplainedSymptoms } from './2025-07-15-doctor-summary';
import { symptomDiary } from './2025-08-22-symptom-diary';
import { whyManualHealthTrackingFails } from './2026-10-28-why-manual-health-tracking-fails';

// Add new posts here — order controls how they appear on the blog page.
export const posts: BlogPost[] = [
  welcomeToToastie,
  howToPrepForGpApptsWithUnexplainedSymptoms,
  symptomDiary,
  whyManualHealthTrackingFails,
];
